import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class CanActivateViaAdminGuard implements CanActivate {
  constructor(private router: Router) {

  }

  public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    let user = Parse.User.current();

    if (!user) {
      this.router.navigate(['admin/login']);
      return false;
    }

    if (user['isAdmin']) {
      return true;
    }

    return new Promise<boolean>((resolve, reject) => {
      Parse.Cloud.run('isAdmin').then(
        (success) => {
          user['isAdmin'] = true;
          return resolve(true);
        },
        (error) => {
          Parse.User.logOut();
          this.router.navigate(['admin/login']);
          return resolve(false);
        }
      );
    });
  }
}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/+admin/route-guards/can-activate-via-admin-guard.ts